<template>
  <button
    v-if="orderStore.hasPrimaryCard && primaryCard"
    class="inline-flex w-full h-12 text-black bg-white border border-black hover:bg-gray-200 mb-3 rounded-lg items-center justify-center font-medium"
    data-testid="primary-card-payment-button"
    :disabled="orderStore.isProcessing"
    @click.prevent="clicked"
  >
    <PaymentCardDescription :card="primaryCard" simple logo-size="large" />
  </button>
  <div v-if="errorMessage" class="text-sm text-red-600 dark:text-red-500 mb-3">
    {{ errorMessage }}
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useCustomerStore } from '@/stores/customer'
import { useAuthStore } from '@/stores/auth'
import { usePaymentStore } from '@/stores/payment'
import { useOrderStore } from '@/stores/order'
import { createOrder } from '@/services/api/orders'
import { TICKETS_ROUTES } from '@/router'
import PaymentCardDescription from '@/components/elements/PaymentCardDescription.vue'
import { getError } from '@/utils/errors'
import { useGoogleTagManagerStore } from '@/stores/google-tag-manager'

const customerStore = useCustomerStore()
const authStore = useAuthStore()
const orderStore = useOrderStore()
const paymentStore = usePaymentStore()
const primaryCard = ref()
const router = useRouter()
const errorMessage = ref()

async function loadPrimaryCardDetails() {
  if (authStore.getToken()) {
    const primaryCardDetails = await customerStore.getPrimaryCardDetails()

    if (primaryCardDetails?.id) {
      primaryCard.value = primaryCardDetails
      orderStore.hasPrimaryCard = true
    }
  }
}

async function clicked() {
  errorMessage.value = null
  orderStore.isProcessing = true
  const resultIntent = await paymentStore.requestPaymentIntentForCof(primaryCard.value.id)

  if (!resultIntent.error) {
    orderStore.customerEmail = resultIntent.customerEmail
    const resultOrder = await createOrder(resultIntent.paymentIntentId, true)

    if (!resultOrder.error) {
      orderStore.updateFromResponse(resultOrder)
      useGoogleTagManagerStore().trackOrderCompleted(orderStore.id, orderStore.total)
      router.push({ name: TICKETS_ROUTES.ORDER_CONFIRMATION, params: { id: orderStore.id } })
    } else {
      errorMessage.value = getError(resultOrder)
    }
  } else {
    errorMessage.value = getError(resultIntent)
  }
  orderStore.isProcessing = false
}

loadPrimaryCardDetails()
</script>

<style scoped></style>
